import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {
    Button, Modal,
    ModalBody as Body,
    ModalFooter as Footer,
    ModalHeader as Header,
    ModalTitle as Title
} from "react-bootstrap";
import GroupedAction from "Entity/Collection/ListingSetting/GroupedAction";
import LoadingButton from "../../Button/LoadingButton";
import Api from "Vendor/Api";
import Collection from "Config/Collection";
import TextType from "../../../Vendor/Components/Form/Type/TextType";
import Property from "../../../Entity/Property";

export interface _PrintStickersModalProps {
    id: number
    showActionModals: {[key: string]: boolean|Property}
    handleShowActionModal: (groupedAction?: GroupedAction, actionFromMain?:boolean) => void
    fromMain: boolean
    handleShowMainActionModal: () => void
    selected: number[]
    actionModalFormIsLoading: boolean
    actionModalFormIsLoaded: boolean,
    setActionModalFormIsLoaded: (isLoaded: boolean) => void,
    handleActionModalOnResponse: () => void
    handleActionModalOnSuccess: () => void
    handleActionModalOnSubmit: () => void
}

const _PrintStickersModal: FC<_PrintStickersModalProps> = ({
                                                               id,
                                                               showActionModals,
                                                               handleShowActionModal,
                                                               fromMain,
                                                               handleShowMainActionModal,
                                                               selected,
                                                               actionModalFormIsLoading,
                                                               actionModalFormIsLoaded,
                                                               setActionModalFormIsLoaded,
                                                               handleActionModalOnResponse,
                                                               handleActionModalOnSuccess,
                                                               handleActionModalOnSubmit,
}) => {
    const {t} = useTranslation()
    const [fileName, setFileName] = useState<string>('')

    const onSubmit = () => {
        handleActionModalOnSubmit()
        Api.post(`/grouped-action/${id}/sticker/print`, {
            fileName: fileName,
            items: selected,
        }, {
            responseType: 'blob'
        })
            .then((response ) => {
                let disposition = response.headers['content-disposition'];
                // get filename from content-disposition
                let filename = disposition?.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');
                // create file link in browser's memory
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                handleActionModalOnSuccess()
            })
            .catch(() => {
            })
            .then(() => {
                handleActionModalOnResponse()
                setFileName('')
            })
    }

    return <Modal show={showActionModals.printStickers !== false} onHide={handleShowActionModal}>
        <Header closeButton={!fromMain}>
            <div className="modal-block-header">
                {fromMain && <i className="fa-solid fa-angle-left" onClick={handleShowMainActionModal}></i>}
                <Title>{t(`app.groupedActionTitle.print_stickers`, {count: selected.length})}</Title>
            </div>
        </Header>
        <Body>
            <TextType required={false} fullName="fileName" id="fileName" name="fileName" value={fileName} onChange={e => setFileName(e.target.value)} i18nLabel="app.groupedActionContent.printStickers.inputLabel" />
        </Body>
        <Footer>
            {!fromMain && <Button variant="secondary" onClick={() => {
                handleShowActionModal()
            }}>
                {t('app.cancel')}
            </Button>}
            <LoadingButton variant="primary" isLoading={actionModalFormIsLoading} onClick={onSubmit}>
                {t('app.print')}
            </LoadingButton>
        </Footer>
    </Modal>
}

export default _PrintStickersModal